import api from './index.js'
const BASE_URL = '/admin/partner-deposit'

export const fetchPartnerDeposits = async (
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString()
    const response = await api.get(
      `${BASE_URL}?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch deposits')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch deposits')
  }
}

export const fetchPartnerDeposit = async id => {
  try {
    const response = await api.get(`${BASE_URL}/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch deposit')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch deposit')
  }
}

export const updatePartnerDeposit = async (id, depositdData) => {
  try {
    const response = await api.put(`${BASE_URL}/${id}`, depositdData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to update deposit status')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to update deposit status')
  }
}

export const createPartnerDeposit = async depositData => {
  try {
    const response = await api.post(`${BASE_URL}`, depositData)

    if (response.status === 200) {
      const data = response.data
      return data
    } else {
      throw new Error('Failed to create partner-deposit')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to create partner-deposit')
  }
}